<script>
    import noData from '../../assets/img/no-data.png';

    export default {
        name: 'no-data',
        props: {
            visible: {
                type: Boolean,
                default: true,
                required: false
            },
            theme:{
                type: String,
                default: 'normal',
                required: false
            }
        },
        data () {
            return {
                noData
            };
        }
    };
</script>
<template>
    <transition name="fade">
        <div class=" no-data" v-show="visible" :class="theme">
            <img :src="noData" alt="">
        </div>
    </transition>
</template>
<style lang="less" scoped>
    .no-data{
        z-index: 3990;
        img {
            position: absolute;
            left: 50%;
            top: 50%;
        }
        &.normal{
            img {
                width: 237px;
                height: 235px;
                margin-left: -118.5px;
                margin-top: -117.5px;
            }
        }
        &.sm{
            img {
                width: 118.5px;
                height: 117.5px;
                margin-left: -59.25px;
                margin-top: -80px;
            }
        }
    }

</style>
